module.exports = __webpack_public_path__ + "img/participation-limit-reached.5427a717.png";